/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementFromJSON, FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirement';
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirements interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirements(value) {
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'EmailRequirement': json['EmailRequirement'] == null ? undefined : FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementFromJSON(json['EmailRequirement']),
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'EmailRequirement': FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementToJSON(value['EmailRequirement']),
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirements.js.map